<template>
	<tr class="border-t">
		<td class="px-3 py-1 text-sm text-gray-500">
			<div class="flex items-center gap-2">
				<AppIcon
					v-if="message.sentOrReceived === 'sent'"
					:name="
						['read', 'confirmed'].includes(message.messageStatus ?? '')
							? 'send'
							: 'schedule_send'
					"
					:class="iconColor"
					class="text-xl"
				/>
				<component :is="messageComponent" :message />
			</div>
		</td>
		<td class="px-3 py-2 text-sm text-gray-500 text-end whitespace-nowrap">
			{{ formatDate(message.sentAt) }}
		</td>
	</tr>
</template>

<script setup lang="ts">
import type { LoanApplicationMessage } from "@/generatedApi";
import { formatDate } from "@/helpers/uiHelpers";
import LoanApplicationMessageRowStatusMelding from "./LoanApplicationMessageRowStatusMelding.vue";
import LoanApplicationMessageRowDocumentBericht from "./LoanApplicationMessageRowDocumentBericht.vue";
import LoanApplicationMessageRowDocumentAanvraagBericht from "./LoanApplicationMessageRowDocumentAanvraagBericht.vue";
import LoanApplicationMessageRowOfferteAanvraag from "./LoanApplicationMessageRowOfferteAanvraag.vue";
import LoanApplicationMessageRowOfferte from "./LoanApplicationMessageRowOfferte.vue";
import { computed, h } from "vue";
import { isKeyOf } from "@/helpers/typeHelpers";

const props = defineProps<{
	message: LoanApplicationMessage;
}>();

const messageComponent = computed(() => {
	const messageRowComponents = {
		StatusMelding: LoanApplicationMessageRowStatusMelding,
		DocumentBericht: LoanApplicationMessageRowDocumentBericht,
		DocumentAanvraagBericht: LoanApplicationMessageRowDocumentAanvraagBericht,
		OfferteAanvraag: LoanApplicationMessageRowOfferteAanvraag,
		Offerte: LoanApplicationMessageRowOfferte,
	};

	const messageType = props.message.messageType;
	if (isKeyOf(messageRowComponents, messageType)) {
		const messageComponent = messageRowComponents[messageType];
		return messageComponent;
	}

	const genericMessageComponent = h("span", props.message.messageType);
	return genericMessageComponent;
});

const iconColor = computed(() =>
	props.message.messageStatus === "confirmed"
		? "text-green-500"
		: "text-gray-500",
);
</script>
